/**
 * Created by B032151 on 11/21/2016.
 */
import createReactClass from "create-react-class";

import React from "react";
import { Panel } from "react-bootstrap";
import { CurrentSchematic } from "../actions/compare/currentSchematic";
import { StageSchematic } from "../actions/compare/stageSchematic";
import { ServerActions } from "../actions/serverActions";
import { CompareDetailsView } from "../components/compareDetails";
import { CompareGuidDetailsView } from "../components/compareGuidDetails";
import { CompareItemDetailsView } from "../components/compareItemDetails";
import { compareDetailsStore } from "../stores/compareDetails";
import { runCompareStore } from "../stores/runCompareStore";

function getStateFromStores() {
  return {
    itemListOpened: compareDetailsStore.getListOpened(),
    itemDetailOpened: compareDetailsStore.getDetailsOpened(),
    divHeight: runCompareStore.getHeight(),
  };
}

export const ComparePage = createReactClass({
  componentDidMount: function () {
    compareDetailsStore.subscribe(this._onChange);
    runCompareStore.subscribe(this._onChange);
    ServerActions.startOutageStateCheck();
    ServerActions.getUserRole();
    ServerActions.getSubdivisionList();
    CurrentSchematic.initialize().then(function (response) {
      console.log("Initialize Current Schematic: ", response);
    });

    StageSchematic.initialize().then(function (response) {
      console.log("Initialize Stage Schematic: ", response);
    });
  },

  componentWillUnmount: function () {
    compareDetailsStore.unsubscribe(this._onChange);
    runCompareStore.unsubscribe(this._onChange);
  },

  getInitialState: function () {
    return getStateFromStores();
  },

  _onChange: function () {
    this.setState(getStateFromStores());
  },

  render: function () {
    var compareItemDetails = <CompareItemDetailsView />;
    var compareGuidDetails = <CompareGuidDetailsView />;
    var compareDetails = <CompareDetailsView />;
    var ht = this.state.divHeight;

    return (
      <div
        id="comparePanel"
        style={{ height: ht + "%", backgroundColor: "#b0c4de" }}
      >
        <Panel>
          <Panel.Body>
            {compareItemDetails}
            {compareGuidDetails}
          </Panel.Body>
        </Panel>
        <Panel>
          <Panel.Body>{compareDetails}</Panel.Body>
        </Panel>
      </div>
    );
  },
});
